import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import {
  Component,
  Input,
  TemplateRef,
  ViewEncapsulation,
  HostBinding,
  ViewChild,
  HostListener,
  AfterViewInit,
  NgZone,
} from '@angular/core';
import { IonContent } from '@ionic/angular';
import { BREAK_LARGE_RESOLUTION } from 'android/app/src/constants/app.contants';
import { Auth } from 'src/providers/auth/auth';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

@Component({
    selector: 'app-scroll-wrapper',
    template: `
    <ion-content cdkIonicScrollable [class.rounded-content]="isfullWidthContent" [scrollY]="true">
      @if (isfullWidthContent) {
        <ng-container *ngTemplateOutlet="templateContent"></ng-container>
      }
      @if (!isfullWidthContent) {
        <div class="content-container">
          <div class="container-item left-column">
            <ng-container *ngTemplateOutlet="templateLeftColumn">
            </ng-container>
          </div>
          <div
            class="container-item tidy-content"
            [ngClass]="desktopWidthContent">
            <ng-container *ngTemplateOutlet="templateContent"> </ng-container>
          </div>
          <div class="container-item right-column">
            <div
              [ngClass]="{
                'wider-right-column': widerRightColumn,
                'scroll-wrapper-grey-content': !showCardDesign,
                'scroll-wrapper-card-content': showCardDesign
              }">
              <ng-container *ngTemplateOutlet="templateRightColumn">
              </ng-container>
            </div>
          </div>
        </div>
      }
    </ion-content>
    `,
    styleUrls: ['./scroll-wrapper.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ScrollWrapperComponent implements AfterViewInit {
  @Input() desktopWidthContent: string = scrollContentWidth.PORTRAIT;
  @Input() templateLeftColumn: TemplateRef<any>;
  @Input() templateContent: TemplateRef<any>;
  @Input() templateRightColumn: TemplateRef<any>;
  @Input() showCardDesign: boolean;
  @Input() widerRightColumn: boolean;
  @Input() isfullWidthContent = false;
  @HostBinding('class.ion-page') get addClass() {
    return true;
  }
  @ViewChild(IonContent, { read: IonContent }) ionContent: IonContent;

  constructor(
    private auth: Auth,
    private rightSidePanelService: RightSidePanelService,
    private navCtrl: CustomNavController,
    private windowService: WindowService,
    private ngZone: NgZone,
    private storage: TidyStorage
  ) {}

  ngAfterViewInit() {
    // Force a resize event after view init to ensure proper content sizing
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.ionContent) {
          this.ionContent.getScrollElement().then(scrollEl => {
            // Reset any Ionic internal calculations
            scrollEl.style.setProperty('--offset-top', '0px');
            scrollEl.style.setProperty('--offset-bottom', '0px');
            scrollEl.style.setProperty('--keyboard-offset', '0px');
          });
        }
      }, 150);
    });
  }

  @HostListener('window:resize')
  async onResize() {
    const isDesktopResolution = window.innerWidth > BREAK_LARGE_RESOLUTION;
    const isAuthenticated = this.auth.isAuthenticated();
    const isRightSidePanelOpened = this.rightSidePanelService.isOpen$.getValue();
    const isSelfBooking = await this.storage.retrieve('isSelfBooking');
    if (isAuthenticated && isDesktopResolution && !this.isfullWidthContent && !isRightSidePanelOpened && !isSelfBooking) {
      this.navCtrl.navigateRoot('/properties');
      this.rightSidePanelService.openRightSidePanelWithTemplate(
        this.templateContent
      );
      this.windowService.windowSize = window.innerWidth;
    }
  }

  async scrollToBottom(duration = 300) {
    if (this.ionContent) {
      await this.ionContent.scrollToBottom(duration);
      // After scrolling, ensure the content is properly sized
      const scrollEl = await this.ionContent.getScrollElement();
      scrollEl.style.setProperty('--offset-top', '0px');
      scrollEl.style.setProperty('--offset-bottom', '0px');
      scrollEl.style.setProperty('--keyboard-offset', '0px');
    }
  }
}

export enum scrollContentWidth {
  LARGE = 'content-column-large max-width-large',
  NORMAL = 'content-column-normal max-width-normal',
  PORTRAIT = 'content-column max-width',
}
